import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { LoaderError, OrderDetails } from '../../../core/model';
import { ORDER_CORE_FEATURE } from '../store/order-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: OrderDetailsFacade,
      feature: ORDER_CORE_FEATURE,
      async: true,
      methods: ['getOrderDetails', 'getOrderDetailsLoading', 'getOrderDetailsLoaded', 'getOrderDetailsError'],
    }),
})
export abstract class OrderDetailsFacade {
  abstract getOrderDetails(orderCode: string, refresh?: boolean, mergeMode?: boolean): Observable<OrderDetails | undefined>;
  abstract getOrderDetailsLoading(orderCode: string): Observable<boolean>;
  abstract getOrderDetailsLoaded(orderCode: string): Observable<boolean>;
  abstract getOrderDetailsError(orderCode: string): Observable<LoaderError | undefined>;
}
